var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-container" },
    [
      _c("v-select", {
        attrs: {
          reduce: function (option) {
            return option.value
          },
          clearable: false,
          options: _vm.initialOptions,
          searchable: false,
        },
        model: {
          value: _vm.currentValue,
          callback: function ($$v) {
            _vm.currentValue = $$v
          },
          expression: "currentValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }